import SolutionIntegrationsI18n from "@/components/landing/shared/SolutionIntegrationsI18n";
const VertriebIntegrationsSection = () => <SolutionIntegrationsI18n translationPrefix="vertriebSolution" />;
export default VertriebIntegrationsSection;
